module.exports = __webpack_public_path__ + "rcb-7f687899e93c928fe293.png";